import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import Skeleton from "react-loading-skeleton";

const LeadNavLinkLoading = () => {

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Row>
                        <div className="px-0">
                            <Col xl='6'>
                                <Table className="mb-0 text-black">
                                    <tbody>
                                        <td className="pe-3">
                                            <Skeleton />
                                        </td>
                                        <td className="pe-3">
                                            <Skeleton />
                                        </td>
                                        <td className="pe-3">
                                            <Skeleton />
                                        </td>
                                        <td className="pe-3">
                                            <Skeleton />
                                        </td>
                                    </tbody>
                                </Table>
                            </Col>
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LeadNavLinkLoading